import { Status, States } from '@sift/resift/models/Status';
import createSingleActionHandlers from '@sift/resift/redux/reducers/createSingleActionHandlers';

// ------------------------------------
// Constants
// ------------------------------------
export const SIFT_BOT_FETCH = 'SIFT_BOT_FETCH';
export const SIFT_BOT_FETCH_SUCCESS = 'SIFT_BOT_FETCH_SUCCESS';
export const SIFT_BOT_FETCH_ERROR = 'SIFT_BOT_FETCH_ERROR';

export const SIFT_BOT_UPDATE = 'SIFT_BOT_UPDATE';
export const SIFT_BOT_UPDATE_SUCCESS = 'SIFT_BOT_UPDATE_SUCCESS';
export const SIFT_BOT_UPDATE_ERROR = 'SIFT_BOT_UPDATE_ERROR';

// ------------------------------------
// Actions
// ------------------------------------
export function fetchSiftBot() {
  return {
    type: SIFT_BOT_FETCH,
    payload: {},
  };
}

export function updateSiftBotFields(fields) {
  return {
    type: SIFT_BOT_UPDATE,
    payload: {
      data: {
        fields,
      },
    },
  };
}

// ------------------------------------
// Actions Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  ...createSingleActionHandlers({
    actionHandler: SIFT_BOT_FETCH,
    statusKey: 'status',
  }),
  [SIFT_BOT_UPDATE]: (state, action) => {
    return {
      ...state,
      status: new Status(States.LOADING | States.NORMAL),
    };
  },
  [SIFT_BOT_UPDATE_SUCCESS]: (state, action) => {
    const newState = {
      ...state,
      ...action.payload.data,
      status: new Status(States.NORMAL),
    };

    return newState;
  },
  [SIFT_BOT_UPDATE_ERROR]: (state, action) => {
    return {
      ...state,
      status: new Status(States.NORMAL), // Snack bar will fire
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  status: new Status(),
  completionPercentage: null,
  fields: [],
};
export default function siftBotReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
